import React, { useState } from "react";
import loginLogo from "../../Assets/Images/brand-logo.png";
// import "../../Assets/Images/loginPage-banner.jpg";
import "../../Pages/LoginPage/LoginPage.scss";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../utils/index";
import Swal from "sweetalert2";
      
function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  
  const handleSubmit = (e) => {
    e.preventDefault();
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      name: name,
      email: email,
      password: verifyPassword,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    axios
      .post(`${API_BASE_URL}/admin/registration`, {
        name: name,
        email: email,
        password: verifyPassword,
      })
      .then((result) => {
        console.log("result Register", result);
        Swal.fire({
          icon: "success",
          title: "Registration Success",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate("/login");
      })
      .catch((error) => {
        console.log("error in registration", error.response.data.message);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
  };

  return (
    <div className="login-page  d-flex align-items-center bg-primary">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="login-logor text-center">
              <img src={loginLogo} alt="loginLogo" />
            </div>
          </div>
          <div className="col-md-6">
            <form className="right" onSubmit={handleSubmit}>
              <p className="login-title">Register</p>
              
              <div className="my-2">
                <input
                  className="form-control"
                  name="name"
                  id="name"
                  placeholder="Name"
                  required
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="my-2">
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email"
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="my-2 input-container">
                <input
                  className="form-control"
                  type={showPassword ? "text" : "password"}
                  name="Password"
                  id="password"
                  value={verifyPassword}
                  placeholder="password"
                  required
                  onChange={(e) => setVerifyPassword(e.target.value)}
                />
                  
                {/* <span
                  className="eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <FaEye className="icon" />
                  ) : (
                    <FaEyeSlash className="icon" />
                  )}
                </span> */}
              </div>

              <div className="my-2">
                <button type="submit" className="btn submit-button">
                  Login
                </button>
              </div>

              <div>
                <input type="checkbox" className="form-check-input" />
                <lable className="form-check-label px-2">
                  Keep me logged in
                </lable>
              </div>
              <Link to="/login" className="text-light">
                Go to Login
              </Link>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
